import { render, staticRenderFns } from "./addInMergeGoods.vue?vue&type=template&id=80e24516&scoped=true&"
import script from "./addInMergeGoods.vue?vue&type=script&lang=js&"
export * from "./addInMergeGoods.vue?vue&type=script&lang=js&"
import style0 from "./addInMergeGoods.vue?vue&type=style&index=0&id=80e24516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e24516",
  null
  
)

component.options.__file = "addInMergeGoods.vue"
export default component.exports